if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('#AgreeToTos');
      this.error = this.querySelector('.terms-checkbox__error');

      if (this.checkbox) {
        this.checkoutButton = this.parentElement.querySelector('#CheckOut') || document.querySelector('#CheckOut');

        this.checkbox.addEventListener('change', () => {
          if (this.checkbox.checked) {
            this.#hideError();
          }
        });

        if (this.checkoutButton) {
          this.checkoutButton.addEventListener('click', event => {
            if (!this.checkbox.checked) {
              event.preventDefault();
              event.stopPropagation();
              this.#showError();
            }
          });
        }
      }
    }

    #showError() {
      if (this.error) {
        this.error.hidden = false;
      }
      this.checkbox.setAttribute('aria-invalid', 'true');
      this.checkbox.focus();
    }

    #hideError() {
      if (this.error) {
        this.error.hidden = true;
      }
      this.checkbox.removeAttribute('aria-invalid');
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
